export const SETTLEMENT_CANCELLED_DOCUMENTS_TITLE = 'Detalles de liquidaciones anuladas:'

export const SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_PLACEHOLDER =
  'Buscar por número de documento o tipo'

export const SETTLEMENT_CANCELLED_DOCUMENTS_EMPTY_STATE = 'No hay resultados'
export const SETTLEMENT_CANCELLED_DOCUMENTS_STATUS_LABEL = 'Anulado'

export const SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_FACTURA = 'factura'
export const SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_CREDITO = 'credito'
export const SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_NOTA_CREDITO = 'nota de credito'

export const SETTLEMENT_CANCELLED_DOCUMENTS_TABLE_HEADERS = [
  'FECHA Y HORA',
  'CÓDIGO',
  'CLIENTE',
  'NÚMERO DE DOCUMENTO',
  'TIPO DE DOCUMENTO',
  'ESTATUS',
  'TOTAL'
]

export const SETTLEMENT_DETAILS_TAB_TITLE = 'Detalles de liquidación:'
export const SETTLEMENT_DETAILS_HEADER_USER_CODE_LABEL = 'Código de usuario:'
export const SETTLEMENT_DETAILS_HEADER_CREATED_AT_LABEL = 'Fecha de creación:'
export const SETTLEMENT_DETAILS_HEADER_RECEIVED_AT_LABEL = 'Fecha de aprobación:'
export const SETTLEMENT_DETAILS_HEADER_RECEIVED_BY_LABEL = 'Aprobado por:'
export const SETTLEMENT_DETAILS_HEADER_USER_LABEL = 'Usuario:'
export const SETTLEMENT_DETAILS_LIQUIDATION_SECTION_TITLE = 'DETALLES DE LIQUIDACIÓN'
export const SETTLEMENT_DETAILS_LIQUIDATION_OPEN_LABEL = 'Abrir detalles de liquidación'
export const SETTLEMENT_DETAILS_LIQUIDATION_CLOSE_LABEL = 'Cerrar detalles de liquidación'
export const SETTLEMENT_DETAILS_APPROVED_BY_LABEL = 'Aprobado por'
export const SETTLEMENT_DETAILS_APPROVAL_DATE_LABEL = 'Fecha de aprobación'
export const SETTLEMENT_DETAILS_ERP_NUMBER_LABEL = 'Número ERP'
export const SETTLEMENT_DETAILS_RECEIPT_TYPE_DEPOSIT = 'Depósito'
export const SETTLEMENT_DETAILS_NOTE_TITLE = 'Nota:'
export const SETTLEMENT_DETAILS_NOTE_MESSAGE =
  'Revise que los métodos de pago registrados, los depósitos asociados y los comprobantes adjuntos sean correctos antes de aprobar.'

export const SETTLEMENT_DETAILS_PAYMENT_METHODS_SECTION_TITLE = 'MÉTODOS DE PAGO'
export const SETTLEMENT_DETAILS_PAYMENT_METHODS_OPEN_LABEL = 'Abrir métodos de pago'
export const SETTLEMENT_DETAILS_PAYMENT_METHODS_CLOSE_LABEL = 'Cerrar métodos de pago'

export const SETTLEMENT_DETAILS_CASH_COUNT_SECTION_TITLE = 'ARQUEO DE CAJA'
export const SETTLEMENT_DETAILS_CASH_COUNT_OPEN_LABEL = 'Abrir arqueo de caja'
export const SETTLEMENT_DETAILS_CASH_COUNT_CLOSE_LABEL = 'Cerrar arqueo de caja'
export const SETTLEMENT_DETAILS_CASH_COUNT_TABLE_ARIA_LABEL = 'Arqueo de caja'
export const SETTLEMENT_DETAILS_CASH_COUNT_DENOMINATION_HEADER = 'Denominación'
export const SETTLEMENT_DETAILS_CASH_COUNT_QUANTITY_HEADER = 'Cantidad'
export const SETTLEMENT_DETAILS_CASH_COUNT_TOTAL_HEADER = 'Total'
export const SETTLEMENT_DETAILS_CASH_REPORTED_LABEL = 'Efectivo reportado'
export const SETTLEMENT_DETAILS_CASH_COUNT_TOTAL_LABEL = 'Total arqueo de caja'
export const SETTLEMENT_DETAILS_CASH_DIFFERENCE_LABEL = 'Diferencia'

export const SETTLEMENT_DETAILS_SUMMARY_SECTION_TITLE = 'RESUMEN DEPÓSITOS'
export const SETTLEMENT_DETAILS_SUMMARY_OPEN_LABEL = 'Abrir resumen depósitos'
export const SETTLEMENT_DETAILS_SUMMARY_CLOSE_LABEL = 'Cerrar resumen depósitos'
export const SETTLEMENT_DETAILS_COLLECTED_CASH_LABEL = 'Efectivo cobrado'
export const SETTLEMENT_DETAILS_COLLECTED_CHECKS_LABEL = 'Cheques cobrados'
export const SETTLEMENT_DETAILS_TOTAL_COLLECTED_LABEL = 'Total cobrado'
export const SETTLEMENT_DETAILS_TOTAL_TO_DEPOSIT_LABEL = 'Total a depositar'
export const SETTLEMENT_DETAILS_TOTAL_DEPOSITED_LABEL = 'Total depositado'
export const SETTLEMENT_DETAILS_BALANCED_TEXT = 'Cuadra correctamente'
export const SETTLEMENT_DETAILS_UNBALANCED_MISSING_PREFIX = 'No cuadra — falta'
export const SETTLEMENT_DETAILS_UNBALANCED_MISSING_SUFFIX = 'por depositar'
export const SETTLEMENT_DETAILS_UNBALANCED_EXTRA_PREFIX = 'No cuadra — sobra'
export const SETTLEMENT_DETAILS_UNBALANCED_EXTRA_SUFFIX = 'depositado'
export const SETTLEMENT_DETAILS_UNBALANCED_TEXT = 'No cuadra'

export const SETTLEMENT_DETAILS_TOTAL_COLLECTED_SUBTITLE = 'Suma de todos los métodos de pago'
export const SETTLEMENT_DETAILS_DELIVERY_CREDIT_TITLE = 'Entregas a crédito'
export const SETTLEMENT_DETAILS_DELIVERY_CREDIT_SUBTITLE = 'Pendiente de cobro'
export const SETTLEMENT_DETAILS_POLICE_PAYMENT_TITLE = 'Pago a policía'
export const SETTLEMENT_DETAILS_POLICE_PAYMENT_SUBTITLE = 'Deducciones'

export const SETTLEMENT_DETAILS_DEPOSITS_TITLE = 'Detalles de depósitos:'
export const SETTLEMENT_DETAILS_DEPOSITS_EMPTY_STATE = 'No hay resultado.'
export const SETTLEMENT_DETAILS_DEPOSITS_BANK_PLACEHOLDER = 'Escoge el nombre del banco'
export const SETTLEMENT_DETAILS_DEPOSITS_DATE_PLACEHOLDER = 'dd/mm/yyyy'
export const SETTLEMENT_DETAILS_DEPOSITS_MISSING_VALUE = 'N/A'
export const SETTLEMENT_DETAILS_DEPOSITS_IMAGE_ARIA_PREFIX = 'Ver'
export const SETTLEMENT_DETAILS_DEPOSITS_IMAGE_ARIA_SINGULAR = 'imagen'
export const SETTLEMENT_DETAILS_DEPOSITS_IMAGE_ARIA_PLURAL = 'imágenes'
export const SETTLEMENT_DETAILS_DEPOSITS_IMAGE_ARIA_SUFFIX = 'del depósito'
export const SETTLEMENT_DETAILS_DEPOSITS_AMOUNT_INPUT_LABEL = 'Monto del depósito'
export const SETTLEMENT_DETAILS_DEPOSITS_NUMBER_INPUT_LABEL = 'Número de depósito'
export const SETTLEMENT_DETAILS_DEPOSITS_REQUIRED_FIELD_MESSAGE = 'Campo obligatorio'
export const SETTLEMENT_DETAILS_DEPOSITS_HEADER_UID = '# DEPÓSITO'
export const SETTLEMENT_DETAILS_DEPOSITS_HEADER_BANK = 'BANCO'
export const SETTLEMENT_DETAILS_DEPOSITS_HEADER_NUMBER = 'NÚMERO DE DEPÓSITO'
export const SETTLEMENT_DETAILS_DEPOSITS_HEADER_DATE = 'FECHA DEL DEPÓSITO'
export const SETTLEMENT_DETAILS_DEPOSITS_HEADER_AMOUNT = 'MONTO'
export const SETTLEMENT_DETAILS_DEPOSITS_HEADER_IMAGE = 'VER IMAGEN'
export const SETTLEMENT_DETAILS_DEPOSITS_HEADER_ACTION = 'ACCIÓN'

export const SETTLEMENT_DETAILS_DISCARD_CHANGES_TITLE = 'Cambios sin guardar'
export const SETTLEMENT_DETAILS_DISCARD_CHANGES_MESSAGE =
  'Hay cambios sin guardar en el depósito editado. Si continúa, esos cambios se perderán.'
export const SETTLEMENT_DETAILS_DISCARD_CHANGES_CONFIRM = 'Continuar'
export const SETTLEMENT_DETAILS_DISCARD_CHANGES_CANCEL = 'Seguir editando'

export const SETTLEMENT_DETAILS_EDIT_ACTION_LABEL = 'Editar'
export const SETTLEMENT_DETAILS_CANCEL_EDIT_ARIA_LABEL = 'Cancelar edición'
export const SETTLEMENT_DETAILS_SAVE_EDIT_ARIA_LABEL = 'Guardar edición'
export const SETTLEMENT_DETAILS_DEPOSIT_UPDATE_ERROR =
  'No se pudo actualizar el depósito. Intente nuevamente.'

export const SETTLEMENT_DOCUMENTS_TITLE = 'Detalles de documentos asociados a esta liquidación:'
export const SETTLEMENT_DOCUMENTS_FILTER_LABEL = 'Filtrar liquidaciones por:'
export const SETTLEMENT_DOCUMENTS_PAYMENT_TYPE_FILTER_TITLE = 'TIPO DE PAGO'
export const SETTLEMENT_DOCUMENTS_DOCUMENT_TYPE_FILTER_TITLE = 'TIPO DE DOCUMENTO'
export const SETTLEMENT_DOCUMENTS_SEARCH_PLACEHOLDER = 'Buscar por número de documento o de cobro'
export const SETTLEMENT_DOCUMENTS_RESET_LABEL = 'Restablecer filtros aplicados'
export const SETTLEMENT_DOCUMENTS_EMPTY_STATE = 'No hay resultados'
export const SETTLEMENT_DOCUMENTS_PAYMENT_TYPE_CASH = 'Contado'
export const SETTLEMENT_DOCUMENTS_PAYMENT_TYPE_CREDIT = 'Crédito'
export const SETTLEMENT_DOCUMENTS_MISSING_VALUE = '-'
export const SETTLEMENT_DOCUMENTS_ROUTE_HEADER = 'CÓDIGO FACT. ELECTRÓNICA'

export const SETTLEMENT_DOCUMENTS_TABLE_HEADERS = [
  'FECHA Y HORA',
  'CÓDIGO',
  'CLIENTE',
  'NÚMERO DE DOCUMENTO',
  'TIPO DE DOCUMENTO',
  'NÚMERO DE COBRO',
  'TIPO DE PAGO',
  'SALDO',
  'PAGADO'
]

export const SETTLEMENT_DOCUMENTS_PAYMENT_TYPE_OPTIONS = [
  {
    value: SETTLEMENT_DOCUMENTS_PAYMENT_TYPE_CASH,
    label: SETTLEMENT_DOCUMENTS_PAYMENT_TYPE_CASH
  },
  {
    value: SETTLEMENT_DOCUMENTS_PAYMENT_TYPE_CREDIT,
    label: SETTLEMENT_DOCUMENTS_PAYMENT_TYPE_CREDIT
  }
]

export const SETTLEMENT_DELIVERED_PRODUCTS_TITLE = 'Detalles de productos entregados:'
export const SETTLEMENT_DELIVERED_PRODUCTS_DOWNLOAD_LABEL = 'Descargar entregados'
export const SETTLEMENT_DELIVERED_PRODUCTS_EMPTY_STATE = 'No hay resultados'
export const SETTLEMENT_DELIVERED_PRODUCTS_MISSING_VALUE = '-'

export const SETTLEMENT_DELIVERED_PRODUCTS_TABLE_HEADERS = [
  'CÓDIGO DE PRODUCTO',
  'CÓDIGO DE BARRA',
  'NOMBRE DEL PRODUCTO',
  'UNIDAD DE VENTA',
  'CANTIDAD'
]

export const SETTLEMENT_PAYMENT_BREAKDOWN_TITLE = 'Detalles de pagos asociados a esta liquidación:'
export const SETTLEMENT_PAYMENT_BREAKDOWN_FILTER_LABEL = 'Filtrar Pagos por:'
export const SETTLEMENT_PAYMENT_BREAKDOWN_PAYMENT_TYPE_FILTER_TITLE = 'TIPO DE PAGO'
export const SETTLEMENT_PAYMENT_BREAKDOWN_BANK_FILTER_TITLE = 'BANCO'
export const SETTLEMENT_PAYMENT_BREAKDOWN_DATE_FILTER_TITLE = 'Fecha del pago'
export const SETTLEMENT_PAYMENT_BREAKDOWN_DATE_RANGE_PLACEHOLDER = 'RANGO FECHA'
export const SETTLEMENT_PAYMENT_BREAKDOWN_SEARCH_PLACEHOLDER = 'Buscar por cobro o referencia'
export const SETTLEMENT_PAYMENT_BREAKDOWN_RESET_LABEL = 'Restablecer filtros aplicados'
export const SETTLEMENT_PAYMENT_BREAKDOWN_EMPTY_STATE = 'No hay resultados'
export const SETTLEMENT_PAYMENT_BREAKDOWN_MISSING_VALUE = '-'
export const SETTLEMENT_PAYMENT_BREAKDOWN_IMAGE_ARIA_SUFFIX = 'del pago'
export const SETTLEMENT_PAYMENT_BREAKDOWN_STATUS_HEADER = 'ESTADO DEL PAGO'
export const SETTLEMENT_PAYMENT_BREAKDOWN_STATUS_TOOLTIP =
  'Indica si el pago sigue vigente o si fue anulado. Los pagos anulados también puedes consultarlos en la pestaña Anulados.'

export const SETTLEMENT_PAYMENT_BREAKDOWN_TABLE_HEADERS = [
  'FECHA Y HORA',
  '# DE COBRO',
  'TIPO DE PAGO',
  'MONTO',
  'BANCO',
  'CUENTA / DESTINO',
  'NÚMERO',
  'REFERENCIA',
  SETTLEMENT_PAYMENT_BREAKDOWN_STATUS_HEADER,
  'IMAGEN',
  'ADJUNTOS'
]

export const SETTLEMENT_REFUND_PRODUCTS_TITLE = 'Detalles de productos rechazados:'
export const SETTLEMENT_REFUND_PRODUCTS_DOWNLOAD_LABEL = 'Descargar rechazos'
export const SETTLEMENT_REFUND_PRODUCTS_EMPTY_STATE = 'No hay resultados'
export const SETTLEMENT_REFUND_PRODUCTS_INVOICE_LINK_LABEL = 'ENLACE A LA FACTURA'
export const SETTLEMENT_REFUND_PRODUCTS_MISSING_VALUE = '-'

export const SETTLEMENT_REFUND_PRODUCTS_TABLE_HEADERS = [
  '# DE FACTURA',
  'CÓDIGO DE PRODUCTO',
  'CÓDIGO DE BARRA',
  'NOMBRE DEL PRODUCTO',
  'MOTIVO DE RECHAZO',
  'UNIDAD DE VENTA',
  'CANTIDAD',
  'PRECIO',
  'TOTAL'
]
